import axios from "axios";
import { Message } from "iview";

const service = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "https://wwwt.jiushixiong.com" : 'https://www.jiushixiong.com',
  timeout: 10000
});

// http response 拦截器
service.interceptors.response.use(
  response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
    if (!data.success && data.message) {
      Message.error(data.message);
      return response.data;
    }
    switch (data.code) {
      case 400:
        if (data.message !== null) {
          Message.error(data.message);
        } else {
          Message.error("系统异常");
        }
        break;
      case 500:
        // 系统异常
        if (data.message !== null) {
          Message.error(data.message);
        } else {
          Message.error("系统异常");
        }
        break;
      default:
        return data;
    }
  },
  async error => {
    // 返回状态码不为200时候的错误处理
    if (error.response) {
      // 其他错误处理
      Message.error(error.response.data.message);
    }
    /* router.push("/login") */
    return Promise.resolve(error);
  }
);

export const get = (url, params) => {
  return service({
    method: "get",
    url: url,
    params: params
  });
};

export const post = (url, data) => {
  return service({
    method: "post",
    url: url,
    data: data,
    headers: {
      "Content-Type": "application/json"
    }
  });
};



// WEBPACK FOOTER //
// ./src/util/request.js